import React from "react";
import SelectField from "./SelectField";

export default function SelectEffort({ options, ...field }) {
  return (
    <SelectField {...field} options={options.filter((o) => o !== "51+")} />
  );
}
